<div #content (mouseenter)="createOverlay()" (mouseleave)="onTerm = false" (mousemove)="updateSub($event)" class="relative highlight">
    <span>
        <ng-content></ng-content>
    </span>
    <div #highlight></div>
</div>